import React from "react";

import { Col, Row, Stack } from "react-bootstrap";

import classNames from "classnames";
import currency from "currency.js";

import { ResaleFragment } from "@api/graphql";
import styles from "@pages/dashboard/DetailsDrawer.module.scss";
import { capitalizeFirstLetter, formatISODateToFormat } from "@util/index";

import { DetailCell } from "../resale_submission/DetailCell";

import { FieldFormatter } from "./FieldFormatter";

interface ResaleDetailsProps {
  resale: ResaleFragment;
}

const RESALE_DETAILS_FORMATTERS: FieldFormatter<ResaleFragment>[] = [
  { title: "Artist", format: (resale: ResaleFragment) => resale.artist_name },
  { title: "ID", format: (resale: ResaleFragment) => resale.resale_id },
  {
    title: "Medium",
    format: (resale: ResaleFragment) =>
      capitalizeFirstLetter(resale.medium?.toLocaleLowerCase().replace(/_/g, " ").replace(/ book/, "' book") ?? ""),
  },
  {
    title: "Details",
    format: (resale: ResaleFragment) => capitalizeFirstLetter(resale.description ?? ""),
  },
  {
    title: "Sold date",
    format: (resale: ResaleFragment) =>
      resale.date_sold && formatISODateToFormat({ isoDate: resale.date_sold, targetDateFormat: "DD/MM/YYYY" }),
  },
  {
    title: "Reported on",
    format: (resale: ResaleFragment) =>
      formatISODateToFormat({ isoDate: resale.reported_on, targetDateFormat: "DD/MM/YYYY" }),
  },
  {
    title: "Resale price",
    format: (resale: ResaleFragment) => currency(resale.resale_price || 0).format(),
  },
  {
    title: "Acquired after 8th June 2010",
    format: (resale: ResaleFragment) => resale.acquired_date_choice,
  },
  {
    title: "Royalty",
    format: (resale: ResaleFragment) => currency(resale.royalty || 0).format(),
  },
];

export const ResaleDetailsDrawer = ({ resale }: ResaleDetailsProps) => (
  <Stack gap={4} className="col-md-10">
    <Row>
      <span className={classNames(styles["stack-label"], "h5")}>Resale details</span>
    </Row>
    <Row>
      {resale &&
        RESALE_DETAILS_FORMATTERS.map(({ title, format }) => (
          <Col md={6} className={styles["detail"]} key={title}>
            <DetailCell title={title} value={format(resale)} />
          </Col>
        ))}
    </Row>
  </Stack>
);
